/* ==========================================================================
   CAPRIMAFFIA - TERRACE / Motor editorial
   Primitivas de movimiento y composicion, activadas por atributos.
   Vanilla puro: IntersectionObserver + rAF + transform. Cero librerias.
   Nada se activa solo: sin el atributo, el elemento no se toca.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  var raf =
    window.requestAnimationFrame ||
    function (fn) {
      return setTimeout(fn, 16);
    };

  /* --- Estado compartido de scroll -------------------------------------
     Un solo listener para todo el motor. Cada modulo se suscribe. */
  var subs = [];
  var ticking = false;
  var lastY = window.pageYOffset || 0;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    raf(function () {
      var y = window.pageYOffset || 0;
      var velocity = y - lastY;
      lastY = y;
      for (var i = 0; i < subs.length; i++) subs[i](y, velocity);
      ticking = false;
    });
  }

  function subscribe(fn) {
    subs.push(fn);
    if (subs.length === 1) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
    fn(window.pageYOffset || 0, 0);
  }

  /* ======================================================================
     1. FLOTACION - [data-cm-float="0.18"]
     El elemento se desplaza a distinta velocidad que la pagina. El valor
     se publica en variables CSS para no pisar otros transform del nodo.
     ====================================================================== */
  function floaters(root) {
    var nodes = root.querySelectorAll('[data-cm-float]:not([data-cm-float-ready])');
    if (!nodes.length) return;

    var list = [];
    Array.prototype.forEach.call(nodes, function (node) {
      node.setAttribute('data-cm-float-ready', 'true');
      if (reduced()) return;
      list.push({
        el: node,
        speed: parseFloat(node.getAttribute('data-cm-float')) || 0.12,
        axis: node.getAttribute('data-cm-float-axis') || 'y',
        vis: false
      });
    });
    if (!list.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            for (var i = 0; i < list.length; i++) {
              if (list[i].el === e.target) list[i].vis = e.isIntersecting;
            }
          });
        },
        { rootMargin: '25% 0px 25% 0px' }
      );
      list.forEach(function (item) {
        io.observe(item.el);
      });
    } else {
      list.forEach(function (item) {
        item.vis = true;
      });
    }

    subscribe(function () {
      var vh = window.innerHeight || 1;
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        if (!item.vis) continue;
        var r = item.el.getBoundingClientRect();
        /* -1 arriba del todo, 0 centrado, 1 abajo del todo */
        var t = (r.top + r.height / 2 - vh / 2) / vh;
        var offset = -t * item.speed * 100;
        if (item.axis === 'x') {
          item.el.style.setProperty('--cm-float-x', offset.toFixed(2) + 'px');
        } else {
          item.el.style.setProperty('--cm-float-y', offset.toFixed(2) + 'px');
        }
      }
    });
  }

  /* ======================================================================
     2. PROGRESO DE SECCION - [data-cm-scrub]
     Publica --cm-progress de 0 a 1 mientras la seccion cruza la pantalla.
     Con eso se anima cualquier cosa desde CSS con calc().
     ====================================================================== */
  function scrub(root) {
    var nodes = root.querySelectorAll('[data-cm-scrub]:not([data-cm-scrub-ready])');
    if (!nodes.length) return;

    var list = [];
    Array.prototype.forEach.call(nodes, function (node) {
      node.setAttribute('data-cm-scrub-ready', 'true');
      list.push({ el: node, vis: true });
    });

    // Sin esto se medía la posición de TODAS las secciones en cada fotograma
    // de scroll, estuvieran o no en pantalla: un recálculo de layout por
    // sección y frame. Ahora solo se mide lo que se está viendo.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            for (var i = 0; i < list.length; i++) {
              if (list[i].el === e.target) list[i].vis = e.isIntersecting;
            }
          });
        },
        { rootMargin: '20% 0px 20% 0px' }
      );
      list.forEach(function (item) {
        item.vis = false;
        io.observe(item.el);
      });
    }

    subscribe(function () {
      var vh = window.innerHeight || 1;
      for (var i = 0; i < list.length; i++) {
        if (!list[i].vis) continue;
        var r = list[i].el.getBoundingClientRect();
        var total = r.height + vh;
        var p = (vh - r.top) / total;
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        list[i].el.style.setProperty('--cm-progress', p.toFixed(4));
      }
    });
  }

  /* ======================================================================
     3. REVELADO TIPOGRAFICO - .cm-type-reveal
     Parte el texto en palabras o letras y las levanta escalonadas.
     data-cm-split="words|chars"   data-cm-step="ms"
     ====================================================================== */
  function typeReveal(root) {
    var nodes = root.querySelectorAll('.cm-type-reveal:not([data-cm-type-ready])');
    if (!nodes.length) return;

    var io =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries, obs) {
              entries.forEach(function (e) {
                if (!e.isIntersecting) return;
                e.target.classList.add('is-in');
                obs.unobserve(e.target);
              });
            },
            { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
          )
        : null;

    Array.prototype.forEach.call(nodes, function (node) {
      node.setAttribute('data-cm-type-ready', 'true');

      if (reduced()) {
        node.classList.add('is-in');
        return;
      }

      var mode = node.getAttribute('data-cm-split') || 'words';
      var step = parseInt(node.getAttribute('data-cm-step') || '0', 10);
      var text = node.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;

      var units = mode === 'chars' ? text.split('') : text.split(' ');
      var html = '';
      for (var i = 0; i < units.length; i++) {
        var unit = units[i] === ' ' ? '&nbsp;' : units[i];
        var style = '--i:' + i + (step ? ';--cm-step:' + step + 'ms' : '');
        html +=
          '<span class="cm-unit" style="' + style + '"><span class="cm-unit__in">' + unit + '</span></span>';
        if (mode !== 'chars' && i < units.length - 1) html += ' ';
      }
      node.innerHTML = html;

      if (io) io.observe(node);
      else node.classList.add('is-in');
    });
  }

  /* ======================================================================
     4. CINTA TIPOGRAFICA - .cm-mq
     Duplica el contenido hasta cubrir el doble del ancho y lo desplaza en
     bucle. La velocidad del scroll la acelera y la inclina un poco.
     ====================================================================== */
  function marquee(root) {
    var nodes = root.querySelectorAll('.cm-mq:not([data-cm-mq-ready])');
    if (!nodes.length) return;

    Array.prototype.forEach.call(nodes, function (node) {
      node.setAttribute('data-cm-mq-ready', 'true');

      var track = node.querySelector('[data-cm-mq-track]');
      if (!track) return;

      var base = parseFloat(node.getAttribute('data-cm-mq-speed')) || 40; /* px/s */
      var dir = node.getAttribute('data-cm-mq-dir') === 'right' ? 1 : -1;
      var reactive = node.getAttribute('data-cm-mq-reactive') !== 'false';
      var original = track.innerHTML;
      var unit = 0;

      function fill() {
        track.innerHTML = original;
        var one = track.scrollWidth;
        if (!one) return 0;
        var need = Math.ceil(((node.offsetWidth || window.innerWidth) * 2) / one) + 1;
        var html = '';
        for (var i = 0; i < need; i++) html += original;
        track.innerHTML = html;
        return one;
      }

      unit = fill();
      if (!unit || reduced()) return;

      var pos = 0;
      var last = 0;
      var boost = 0;

      subscribe(function (y, v) {
        if (reactive) boost = v;
      });

      function tick(now) {
        var dt = last ? Math.min((now - last) / 1000, 0.05) : 0;
        last = now;
        if (node.classList.contains('is-paused')) {
          raf(tick);
          return;
        }
        var extra = reactive ? Math.abs(boost) * 6 : 0;
        pos += dir * (base + extra) * dt;
        if (pos <= -unit) pos += unit;
        if (pos >= unit) pos -= unit;
        track.style.transform = 'translate3d(' + pos.toFixed(2) + 'px,0,0)';
        if (reactive) {
          var skew = Math.max(-5, Math.min(5, boost * 0.2));
          node.style.setProperty('--cm-mq-skew', skew.toFixed(2) + 'deg');
          boost *= 0.86;
        }
        raf(tick);
      }
      raf(tick);

      window.addEventListener('resize', function () {
        var again = fill();
        if (again) unit = again;
      });
    });

    /* Boton de pausa: para todas las cintas de su seccion */
    var buttons = root.querySelectorAll('[data-cm-mq-pause]:not([data-cm-mq-pause-ready])');
    Array.prototype.forEach.call(buttons, function (btn) {
      btn.setAttribute('data-cm-mq-pause-ready', 'true');
      var scope = btn.closest('.shopify-section') || document;
      var label = btn.querySelector('[data-cm-mq-pause-label]');
      var original = label ? label.textContent : '';

      btn.addEventListener('click', function () {
        var rows = scope.querySelectorAll('.cm-mq');
        var paused = btn.getAttribute('aria-pressed') === 'true';
        Array.prototype.forEach.call(rows, function (row) {
          row.classList.toggle('is-paused', !paused);
        });
        btn.setAttribute('aria-pressed', paused ? 'false' : 'true');
        if (label) label.textContent = paused ? original : 'CONTINUAR';
      });
    });
  }

  /* ======================================================================
     5. INDICE CON VISTA PREVIA - .cm-peek
     Lista de entradas; al pasar por una, su foto sigue al cursor.
     En tactil no hay cursor: la foto se queda quieta en su hueco.
     ====================================================================== */
  function peek(root) {
    var nodes = root.querySelectorAll('.cm-peek:not([data-cm-peek-ready])');
    if (!nodes.length) return;

    Array.prototype.forEach.call(nodes, function (list) {
      list.setAttribute('data-cm-peek-ready', 'true');

      var stage = list.querySelector('[data-cm-peek-stage]');
      if (!stage) return;
      if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

      list.classList.add('cm-peek--live');

      var items = list.querySelectorAll('[data-cm-peek-item]');
      var tx = 0;
      var ty = 0;
      var cx = 0;
      var cy = 0;
      var running = false;

      function loop() {
        cx += (tx - cx) * 0.14;
        cy += (ty - cy) * 0.14;
        stage.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
        if (running) raf(loop);
      }

      list.addEventListener(
        'pointermove',
        function (e) {
          var r = list.getBoundingClientRect();
          tx = e.clientX - r.left;
          ty = e.clientY - r.top;
        },
        { passive: true }
      );

      Array.prototype.forEach.call(items, function (item, index) {
        item.addEventListener('pointerenter', function () {
          stage.setAttribute('data-cm-peek-active', index);
          stage.classList.add('is-on');
          if (!running) {
            running = true;
            cx = tx;
            cy = ty;
            raf(loop);
          }
        });
      });

      list.addEventListener('pointerleave', function () {
        stage.classList.remove('is-on');
        stage.removeAttribute('data-cm-peek-active');
        running = false;
      });
    });
  }

  /* ======================================================================
     6. CIFRAS QUE SUBEN - [data-cm-count]
     ====================================================================== */
  function counters(root) {
    var nodes = root.querySelectorAll('[data-cm-count]:not([data-cm-count-ready])');
    if (!nodes.length || !('IntersectionObserver' in window)) return;

    function pad(val, width) {
      var s = String(val);
      while (s.length < width) s = '0' + s;
      return s;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          obs.unobserve(e.target);

          var el = e.target;
          var to = parseFloat(el.getAttribute('data-cm-count')) || 0;
          var width = parseInt(el.getAttribute('data-cm-count-pad') || '0', 10);
          var dur = 1400;

          if (reduced()) {
            el.textContent = width ? pad(to, width) : to;
            return;
          }

          var t0 = 0;
          function step(now) {
            if (!t0) t0 = now;
            var p = Math.min((now - t0) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            var val = Math.round(to * eased);
            el.textContent = width ? pad(val, width) : val;
            if (p < 1) raf(step);
          }
          raf(step);
        });
      },
      { threshold: 0.6 }
    );

    Array.prototype.forEach.call(nodes, function (n) {
      n.setAttribute('data-cm-count-ready', 'true');
      io.observe(n);
    });
  }

  /* ======================================================================
     7. HOVER MAGNETICO - [data-cm-magnet]
     ====================================================================== */
  function magnet(root) {
    if (reduced()) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

    var nodes = root.querySelectorAll('[data-cm-magnet]:not([data-cm-magnet-ready])');
    Array.prototype.forEach.call(nodes, function (el) {
      el.setAttribute('data-cm-magnet-ready', 'true');
      var force = parseFloat(el.getAttribute('data-cm-magnet')) || 0.25;

      el.addEventListener(
        'pointermove',
        function (e) {
          var r = el.getBoundingClientRect();
          var dx = (e.clientX - (r.left + r.width / 2)) * force;
          var dy = (e.clientY - (r.top + r.height / 2)) * force;
          el.style.setProperty('--cm-magnet-x', dx.toFixed(1) + 'px');
          el.style.setProperty('--cm-magnet-y', dy.toFixed(1) + 'px');
        },
        { passive: true }
      );

      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--cm-magnet-x', '0px');
        el.style.setProperty('--cm-magnet-y', '0px');
      });
    });
  }

  /* ======================================================================
     8. ENTRADA GENERICA - .cm-in
     Como el .cm-reveal del sistema, pero independiente, para las piezas
     nuevas. Escalona hermanos con [data-cm-stagger].
     ====================================================================== */
  function enter(root) {
    var nodes = root.querySelectorAll('.cm-in:not([data-cm-in-ready])');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) {
        n.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    Array.prototype.forEach.call(nodes, function (node, i) {
      node.setAttribute('data-cm-in-ready', 'true');
      var step = parseInt(node.getAttribute('data-cm-stagger') || '0', 10);
      if (step > 0 && !node.style.getPropertyValue('--cm-in-delay')) {
        node.style.setProperty('--cm-in-delay', (i % 12) * step + 'ms');
      }
      io.observe(node);
    });
  }

  /* ====================================================================== */
  function init(root) {
    var scope = root || document;
    try { enter(scope); } catch (e) {}
    try { typeReveal(scope); } catch (e) {}
    try { floaters(scope); } catch (e) {}
    try { scrub(scope); } catch (e) {}
    try { marquee(scope); } catch (e) {}
    try { peek(scope); } catch (e) {}
    try { counters(scope); } catch (e) {}
    try { magnet(scope); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });

  window.CMEditorial = { init: init };
})();
